module.exports = __webpack_public_path__ + "static/media/22.2e58b3a4.mp3";